import { normalizeNavigationPreferences } from "./navigationPreferences";

const initialsFor = (value, fallback) => String(value || fallback)
  .trim()
  .split(/\s+/)
  .filter(Boolean)
  .map((part) => part[0])
  .join("")
  .slice(0, 2)
  .toUpperCase() || fallback;

export const createLocalWorkspaceData = ({
  businessName,
  legalName = "",
  businessLogo = "",
  ownerName,
  email = "",
  countryCode = "",
  location = "",
  currency = "EUR",
  workspaceName = "",
  businessType = "company",
  navigationPreferences,
}, now = new Date()) => {
  const workspaceId = "personal-local-workspace";
  const businessId = "personal-local-business";
  const ownerId = "personal-local-owner";
  const name = String(businessName || "").trim();
  const owner = String(ownerName || "").trim();
  const normalizedEmail = String(email || "").trim();
  const occurredAt = now.toISOString();
  const profile = {
    id: ownerId,
    workspaceId,
    name: owner,
    email: normalizedEmail,
    role: "Owner",
    initials: initialsFor(owner, "OW"),
    publicMode: false,
    status: "Active",
    businessIds: ["*"],
    accountingPermissions: ["*"],
    interfaceLanguage: "en",
    navigationPreferences: normalizeNavigationPreferences(navigationPreferences),
  };

  return {
    workspaces: [{ id: workspaceId, name: String(workspaceName || name).trim() || name, type: "Local workspace", email: normalizedEmail, currency, logo: String(businessLogo || "") }],
    businesses: [{
      id: businessId,
      workspaceId,
      name,
      legalName: String(legalName || "").trim() || name,
      email: normalizedEmail,
      location: String(location || "").trim(),
      countryCode,
      currency,
      vatStatus: "not-registered",
      vatNumber: "",
      initials: initialsFor(name, "BU"),
      logo: String(businessLogo || ""),
      tone: "orange",
      businessType,
      contacts: [],
      engagement: {
        pricingEnabled: false,
        feeAmount: "",
        feeCurrency: currency,
        feeCadence: "Monthly",
        pricingNote: "",
        internalNotes: "",
        relationshipStatus: "Active",
      },
    }],
    clients: [],
    services: [],
    invoices: [],
    invoiceStatuses: {},
    archivedInvoiceIds: [],
    activityLog: [{ id: "personal-workspace-created", workspaceId, actorId: ownerId, actor: owner, actorRole: "Owner", action: "Local workspace created", detail: `${name} was set up on this device`, entityType: "organization", entityId: workspaceId, at: occurredAt, safeChanges: {} }],
    teamMembers: [{ ...profile, jobTitle: "Owner", managerId: "" }],
    intakeItems: [],
    documentExpectations: [],
    bankTransactions: [],
    quickBooksExports: [],
    accountingSourceSummaries: [],
    accountingMappings: [],
    vatBookPeriods: [],
    fixedAssets: [],
    ledgerAccounts: [],
    communications: [],
    workReminders: [],
    workTasks: [],
    workItemActivities: [],
    profile,
    sampleWorkspace: false,
  };
};

export const createEmptyLocalWorkspaceData = (detailsOrNow = {}, suppliedNow = new Date()) => {
  const details = detailsOrNow instanceof Date ? {} : detailsOrNow;
  const now = detailsOrNow instanceof Date ? detailsOrNow : suppliedNow;
  const data = createLocalWorkspaceData({
    businessName: String(details.workspaceName || "My local workspace").trim() || "My local workspace",
    ownerName: String(details.ownerName || "Local owner").trim() || "Local owner",
    email: details.email || "",
    currency: details.currency || "EUR",
    navigationPreferences: details.navigationPreferences,
  }, now);
  return {
    ...data,
    businesses: [],
    activityLog: [{
      ...data.activityLog[0],
      id: "empty-local-workspace-created",
      detail: "An empty local workspace was opened on this device",
    }],
  };
};
